import { Link } from "gatsby";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const Partner = () => {
  return (
    <div className="partner-usa p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="partner_content">
              <h2>
                Collaborate with the Right Cross-Platform App Development
                Company
              </h2>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <p>
              As a leading cross-platform app development company, we specialize
              in crafting impactful apps that not only capture attention but
              also drive tangible results.{" "}
            </p>
            <p>
              With a wealth of experience and platform expertise, we stand as
              pioneers in cross-platform{" "}
              <Link to="https://www.tekrevol.com/mobile-app-development">
                mobile app development
              </Link>{" "}
              services.
            </p>
          </Col>
        </Row>
        <Row className="h-100 partner_padd">
          <Col xs={12} md={4} lg={4} xl={4} xxl={4}>
            <div className="partner-num">3rd</div>
            <div className="partner-para">
              <p>
                Among Top Mobile App Development Companies in 2023 on Rightfirms
              </p>
            </div>
          </Col>
          <Col xs={12} md={4} lg={4} xl={4} xxl={4}>
            <div className="partner-num">4th</div>
            <div className="partner-para">
              <p>Top Android App Developers in Houston by Clutch</p>
            </div>
          </Col>
          <Col xs={12} md={4} lg={4} xl={4} xxl={4}>
            <div className="partner-num">4.9</div>
            <div className="partner-para">
              <p>Average Review Rating on Clutch</p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Partner;
